import React from 'react';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DeleteForeverOutlined } from '@material-ui/icons';
import { OnwardChip } from '@/styles/blocks';
import { Body1 } from '../blocks';
import { EmailHeading, OptionDescription, OptionName } from './blocks';

const EmailSubscriptionRow = ({
    group,
    bottomSpacing = false,
    commOptions,
    loading,
    setDeleteModal,
    handleUpdateCommunications,
}) => {
    const { selected } = group;

    return (
        <Grid
            item
            container
            direction="column"
            css={css`
                margin-bottom: ${bottomSpacing ? '3rem' : '1.5rem'};
            `}
        >
            <Grid
                item
                container
                direction="row"
                css={css`
                    align-items: end;
                `}
            >
                <Grid
                    item
                    xs={11}
                    css={css`
                        padding-right: 1rem;
                    `}
                >
                    <EmailHeading>{group.email}</EmailHeading>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        disabled={loading}
                        aria-label={`Remove ${group.email}`}
                        onClick={() => setDeleteModal(group)}
                    >
                        <DeleteForeverOutlined color={loading ? 'disabled' : 'error'} />
                    </IconButton>
                </Grid>
            </Grid>
            <Grid
                item
                xs={12}
                css={css`
                    margin-top: 0.25rem;
                `}
            >
                <Body1>
                    {selected.length === 1
                        ? 'Subscribed to 1 notification'
                        : `Subscribed to ${selected.length} notifications`}
                </Body1>
            </Grid>
            <Grid
                item
                xs={12}
                css={css`
                    margin-top: 0.25rem;
                `}
            >
                <Autocomplete
                    id={`subscription-comms-${group.email}`}
                    disabled={loading}
                    multiple
                    fullWidth
                    disableCloseOnSelect
                    // The clear indicator would wipe every notification in one unconfirmed click,
                    // duplicating the trash can. Removing the address is the trash can's job.
                    disableClearable
                    value={selected}
                    options={commOptions}
                    groupBy={(option) => option.section}
                    getOptionSelected={(option, value) => option.communication_id === value.communication_id}
                    getOptionLabel={(option) => option.name || option.label || ''}
                    renderOption={(option) => (
                        <div>
                            <OptionName>{option.name || option.label}</OptionName>
                            {option.description && <OptionDescription>{option.description}</OptionDescription>}
                        </div>
                    )}
                    renderInput={(params) => <TextField {...params} label="Add Notifications" />}
                    renderTags={(options, getTagProps) =>
                        options.map((option, index) => (
                            <OnwardChip
                                label={option.name || option.label}
                                {...getTagProps({ index })}
                                key={option.communication_id}
                                disabled={loading}
                                onDelete={() =>
                                    handleUpdateCommunications(
                                        group,
                                        options.filter((_, i) => i !== index)
                                    )
                                }
                            />
                        ))
                    }
                    onChange={(e, value = []) => handleUpdateCommunications(group, value)}
                />
            </Grid>
        </Grid>
    );
};

export default EmailSubscriptionRow;
